import moment from 'moment';
import { apiDriverApp } from '../../../../../../libs/apiDriverApp';

export const useFormReportsApi = () => {
   const fetchObserverFormResponses = async (startDate, endDate) => {
      try {
         let url = `/api/forms/responses/driver-observation-report/`;
         if (startDate || endDate) {
            url += '?';
            const params = [];
            if (startDate) {
               params.push(`start_date=${startDate}`);
            }
            if (endDate) {
               params.push(`end_date=${endDate}`);
            }
            url += params.join('&');
         }

         const { data } = await apiDriverApp.get(url);

         return data.results.map(formatRecord);
      } catch (error) {
         console.log(error);
         throw new Error('Error fetching observer form responses');
      }
   };

   // ============================
   // Helpers
   // ============================

   // If the API sends null, undefined, or "" → returns "-"
   const normalizeValue = (value) => (value !== null && value !== undefined && value !== '' ? value : '-');

   const formatRecord = (record) => {
      const formatted = {};

      for (const key in record) {
         const value = record[key];

         if (key === 'Submission Date') {
            // SPECIAL CASE
            formatted[key] = formatSubmissionDate(value);
         } else {
            formatted[key] = normalizeValue(value);
         }
      }

      return formatted;
   };

   // >>> SPECIAL CASE FOR SUBMISSION DATE <<<
   const formatSubmissionDate = (isoString) => {
      if (!isoString) return '-';

      return moment(isoString).utc().format('MM-DD-YYYY hh:mm:ss A');
   };

   return {
      fetchObserverFormResponses,
   };
};
